import React from 'react';
import styled from 'styled-components';
import { useObserver } from 'mobx-react';

import useInstoreCart from 'hooks/use-instore-cart';
import { InstoreCartItem } from './instore-cart-item';

export const InstoreCartItems = (): JSX.Element => {
  const InstoreCart = useInstoreCart();
  const items = useObserver(() => InstoreCart.items);
  return (
    <Items data-testid='instore-cart-items'>
      {items.map((item) => (
        <InstoreCartItem key={`${String(item.brandName)}-${String(item.name)}`} item={item} />
      ))}
    </Items>
  );
};

const Items = styled.ul`
  margin: 0 auto;
  padding-left: 0;
  list-style-type: none;
`;
